document.addEventListener("DOMContentLoaded", function () {
  // ── Drawer Mega Menu Panels ───────────────────────────────────────
  const navDrawer = document.getElementById('nav-drawer');
  if (navDrawer) {
    // Open panel on arrow button click
    navDrawer.addEventListener('click', function(e) {
      const openBtn = e.target.closest('[data-megamenu-open]');
      if (openBtn) {
        const id = openBtn.getAttribute('data-megamenu-open');
        const panel = navDrawer.querySelector('[data-megamenu-panel="' + id + '"]');
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        }
        return;
      }

      // Close panel on back button click
      const closeBtn = e.target.closest('[data-megamenu-close]');
      if (closeBtn) {
        const panel = closeBtn.closest('.drawer-mega-panel');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
          // Collapse all open groups when going back
          panel.querySelectorAll('[data-collapsible-trigger].is-expanded').forEach(function(t) {
            t.dispatchEvent(new Event('click', { bubbles: true }));
          });
        }
        return;
      }

    });

    // When drawer closes, reset all panels
    const drawerToggleBtns = document.querySelectorAll('[data-drawer-toggle]');
    drawerToggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(function() {
          navDrawer.querySelectorAll('.drawer-mega-panel.is-open').forEach(function(p) {
            p.classList.remove('is-open');
            p.setAttribute('aria-hidden', 'true');
          });
          navDrawer.querySelectorAll('.drawer-mega-panel [data-collapsible-trigger].is-expanded').forEach(function(t) {
            t.dispatchEvent(new Event('click', { bubbles: true }));
          });
        }, 350);
      });
    });
  }


  // ── Legacy Image-with-menu (corner-blog-nav) ──────────────────────
  const blogNavs = document.querySelectorAll(".corner-blog-nav");
  if (blogNavs.length) {
    blogNavs.forEach(blogNav => {
      const parentNav = blogNav.closest("a.navlink");
      const megaMenu = document.querySelector(".dropdown_container");
      if (!parentNav || !megaMenu) return;

      parentNav.addEventListener("mouseenter", () => {
        megaMenu.classList.add('active');
        parentNav.classList.add('active');
      });
      megaMenu.addEventListener("mouseenter", () => {
        megaMenu.classList.add('active');
        parentNav.classList.add('active');
      });
      parentNav.addEventListener("mouseleave", () => {
        megaMenu.classList.remove('active');
        parentNav.classList.remove('active');
      });
      megaMenu.addEventListener("mouseleave", () => {
        megaMenu.classList.remove('active');
        parentNav.classList.remove('active');
      });
    });
  }

  // ── Mega Menu Sidebar ────────────────────────────────────────────
  const mmSidebarMenus = document.querySelectorAll("[data-mega-menu-sidebar]");
  if (mmSidebarMenus.length) {
    const navItemsForSidebar = Array.from(
      document.querySelectorAll(".menu__items > .menu__item")
    );
    mmSidebarMenus.forEach(menu => {
      const pos = parseInt(menu.dataset.triggerItem, 10);
      const triggerItem = navItemsForSidebar[pos - 1];
      if (!triggerItem) return;
      let hideTimer = null;
      function showSidebar() {
        clearTimeout(hideTimer);
        menu.classList.add('active');
        triggerItem.classList.add('mms-active');
      }
      function scheduleSidebarHide() {
        hideTimer = setTimeout(function () {
          menu.classList.remove('active');
          triggerItem.classList.remove('mms-active');
        }, 80);
      }
      triggerItem.addEventListener("mouseenter", showSidebar);
      triggerItem.addEventListener("mouseleave", scheduleSidebarHide);
      menu.addEventListener("mouseenter", showSidebar);
      menu.addEventListener("mouseleave", scheduleSidebarHide);
    });
  }

  // ── Mega Menu V2 ─────────────────────────────────────────────────
  const mmv2Menus = document.querySelectorAll("[data-mega-menu-v2]");
  if (!mmv2Menus.length) return;

  // All top-level .menu__item divs inside .menu__items
  const navItems = Array.from(
    document.querySelectorAll(".menu__items > .menu__item")
  );

  mmv2Menus.forEach(menu => {
    const pos = parseInt(menu.dataset.triggerItem, 10);
    const triggerItem = navItems[pos - 1];
    if (!triggerItem) return;

    let hideTimer = null;

    function showMenu() {
      clearTimeout(hideTimer);
      menu.classList.add('active');
      triggerItem.classList.add('mmv2-active');
    }

    function scheduleHide() {
      hideTimer = setTimeout(function () {
        menu.classList.remove('active');
        triggerItem.classList.remove('mmv2-active');
      }, 80);
    }

    triggerItem.addEventListener("mouseenter", showMenu);
    triggerItem.addEventListener("mouseleave", scheduleHide);
    menu.addEventListener("mouseenter", showMenu);
    menu.addEventListener("mouseleave", scheduleHide);
  });
});
